module.exports = __webpack_public_path__ + "img/6.a7056f90.jpg";